<!--  -->
<template>
  <div class="imgbox">
    <img class="imgUrl" src="@/assets/images/404@2x.png" alt="" />
    <div class="text">该链接已失效</div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {};
  },
};
</script>
<style scoped>
.imgbox {
  position: relative;
}
.imgUrl {
  margin-top: 106px;
  width: 100%;
}
.text {
  width: 100%;
  position: absolute;
  bottom: 80px;
  left: 0;
  text-align: center;
  color: #999;
  font-size: 18px;
  font-family: PingFangSC-Regular;

}
</style>
